import TriggerConfigSerializer from 'eflex/serializers/trigger-config';

export default class PlcHardwareTriggerConfigSerializer extends TriggerConfigSerializer {}
